
// 不同环境不同地址
let isTest = true
const apis = {
	production: 'https://yhkz.com', // 线上 (生成环境)
	development: 'http://fzmanage.yhkz.cn:8082', // 开发环境http://117.119.65.4:9998
	test: 'http://fzmanage.yhkz.cn:8082' //(测试环境)http://fzmanage.yhkz.cn:8082
  }
export default {
	// api请求地址
	//测试地址 http://117.119.65.4:9180
	baseUrl: process.env.VUE_APP_CURRENTMODE === 'prod' ? apis.production : process.env.VUE_APP_CURRENTMODE === 'test' ? apis.test : apis.development,
	// 域名
	prUrl:process.env.VUE_APP_CURRENTMODE === 'prod' ? 'https://yhkz.com/' : process.env.VUE_APP_CURRENTMODE === 'test' ? 'http://fzmanage.yhkz.cn:8082/' : 'http://localhost:8080/',
	// 图片域名
	imgDomain: '',

	// 腾讯地图key
	mpKey: '',

	// 客服
	webSocket: '',

	// api安全
	apiSecurity: "",

	//本地端主动给服务器ping的时间, 0 则不开启 , 单位秒
	pingInterval: 1500,

	// 公钥
	publicKey: ``,
}
